import React from 'react';
import './ProfileHeader.css';
import ContactButtons from './ContactButtons';
import { FaMapMarkerAlt } from 'react-icons/fa';

function ProfileHeader() {
    return (
        <div className="profile-header">
            <img src="https://ebizcard.vercel.app/_next/image?url=http%3A%2F%2Fres.cloudinary.com%2Fdl5gttary%2Fimage%2Fupload%2Fv1701505767%2Fcampalazzo%2Fld8ptlicdz5yde5oxtdh.png&w=3840&q=75" alt="Profile" className="profile-image" />
            <h1>Ms Jamira Rita</h1>
            <p>Professional cleaner ensuring spotless, hygienic spaces with reliable service.</p>
            <p><FaMapMarkerAlt/> Al Danah - Zone 1 - Abu Dhabi</p>
            <ContactButtons/>
        </div>
    );
}

export default ProfileHeader;
